
import React from 'react';

import { Dialog } from '../../base/dialog';
import { MEDIA_TYPE } from '../../base/media';
import { getLocalParticipant, getParticipantDisplayName } from '../../base/participants';
import {
    Container,
    Text
} from '../../base/react';
import { FontFamily } from '../../base/styles';
import { forceMuteAllParticipants } from '../actions';

import AbstractMuteRemoteParticipantDialog, {
    type Props as AbstractProps
} from './AbstractMuteRemoteParticipantDialog';

/**
 * The type of the React {@code Component} props of
 * {@link AbstractMuteEveryoneDialog}.
 */
export type Props = AbstractProps & {

    content: string,
    exclude: Array<string>,
    title: string,
    _lockAudio: boolean,
    content2: string,
    title1: string
};

/**
 *
 * An abstract Component with the contents for a dialog that asks for confirmation
 * from the user before muting all remote participants.
 *
 * @augments AbstractMuteRemoteParticipantDialog
 */
class AbstractForceMuteEveryoneDialog<P: Props> extends AbstractMuteRemoteParticipantDialog<P> {
    static defaultProps = {
        exclude: [],
        muteLocal: false
    };

    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        const { t } = this.props;

        return (
            <Dialog
                okKey = 'dialog.muteParticipantsVideoButton'
                onSubmit = { this._onSubmit }
                titleString = 'Mute'
                width = 'small'>
                <Container>
                    <Text style = {{ fontFamily: FontFamily.regular }}>
                        {t('addProple.doYouWantToRemoveThisPerson')}
                    </Text>
                </Container>
            </Dialog>
        );
    }

    _onSubmit: () => boolean;

    /**
     * Callback to be invoked when the value of this dialog is submitted.
     *
     * @returns {boolean}
     */
    _onSubmit() {
        const {
            dispatch,
            exclude
        } = this.props;


        dispatch(forceMuteAllParticipants(exclude, MEDIA_TYPE.AUDIO));

        return true;
    }
}

/**
 * Maps (parts of) the Redux state to the associated {@code AbstractMuteEveryoneDialog}'s props.
 *
 * @param {Object} state - The redux state.
 * @param {Object} ownProps - The properties explicitly passed to the component.
 * @returns {Props}
 */
export function abstractMapStateToProps(state: Object, ownProps: Props) {
    const { exclude = [], t } = ownProps;
    const { lockAudio } = state['features/base/conference'];

    const partipicipantss = state['features/base/participants'];

    const remoteLockAudios = Object.values(lockAudio).filter(
            participantId => partipicipantss.find(p => p.local) && partipicipantss.find(p => p.id === participantId)?.role !== 'moderator'
    );


    const fMutedorNot = Object.values(remoteLockAudios).some(value => Boolean(value));

    const whom = exclude

        .map(id => {
            if (id === getLocalParticipant(state).id) {
                return t('dialog.muteEveryoneSelf');
            }

            return getParticipantDisplayName(state, id);
        })
        .join(', ');

    return whom.length ? {
        content: t('dialog.forceMuteEveryoneElseDialog'),
        title: t('dialog.forceMuteEveryoneElseTitle', { whom }),
        content2: t('dialog.unforceMuteEveryoneElseDialog'),
        title1: t('dialog.unforceMuteEveryoneElseTitle', { whom }),
        _lockAudio: fMutedorNot
    } : {
        content: t('dialog.forceMuteEveryoneDialog'),
        title: t('dialog.forceMuteEveryoneTitle'),
        content2: t('dialog.unforceMuteEveryoneDialog'),
        title1: t('dialog.unforceMuteEveryoneTitle'),
        _lockAudio: fMutedorNot
    };
}

export default AbstractForceMuteEveryoneDialog;


